import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, of, from, Subscription } from 'rxjs';
import { map, concatMap } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { SecurityGroups, SecurityGroupMembers } from 'src/app/shared/securitygroups';
import { ClientApiService } from 'src/app/services/client-api.service';
import { SecureApiService } from 'src/app/services/secure-api.service';

@Component({
  selector: 'app-edit-access-groups-tab',
  templateUrl: './edit-access-groups-tab.component.html',
  styleUrl: './edit-access-groups-tab.component.css',
  encapsulation: ViewEncapsulation.None

})
export class EditAccessGroupsTabComponent implements OnInit, OnDestroy {

  public userAccessGroup: number = null;
  public mainCompany: number = null;

  securityGroups: SecurityGroups[]= [];

  selectedFilterGroups: SecurityGroups[] = [];
  securityGroupsClone: SecurityGroups[] = [];
  securityGroupsEditor: SecurityGroups[] = [];

  sgTotalRecords: number = 0;
  selectedSecurityGroup: SecurityGroups = null;
  editedSecurityGroup: SecurityGroups = null;

  private securityQuery: Subscription = null;
  private saveSecurityQuery: Subscription = null;

  @ViewChild('SG1') sgTable: Table;

  constructor(
    private secApi: SecureApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
  ) {
  }

  ngOnDestroy(): void {
    console.log('*** EditUserAccessTabComponent ngOnDestroy: ')

    if (this.securityQuery) { this.securityQuery.unsubscribe(); }
    if (this.saveSecurityQuery) { this.saveSecurityQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** EditUserAccessTabComponent onInit');

    this.globalsettingsservice.getGlobalSettings();

    this.userAccessGroup = this.globalsettingsservice.getAccessGroup();

    this.mainCompany = this.globalsettingsservice.getMainCompanyId();

    this.loadAccessGroupsInfo();
  }

  loadAccessGroupsInfo() {
    this.securityQuery =
      this.secApi.getSecurityGroupList().pipe(
        concatMap(data => {
          this.securityGroups = data.filter(e => e.SECGROUPID <= this.userAccessGroup);
          this.securityGroups.forEach(sg => { sg.uid = sg.SECGROUPID; sg.cloneIndex = 0; });

          this.securityGroupsEditor = [... this.securityGroups];

          environment.production || console.table(this.securityGroups);

          return of(this.globalsettingsservice.getMainCompanyId());
        }),
      )
        .subscribe({
          error: err => {
            console.error('*** EditAccessGroupsTabComponent loadAccessGroupsInfo: Error: ' + err);
            this.messageService.add(err?.status === 403
              ? { severity: 'error', summary: 'Недостаточно прав', detail: 'Требуется роль portal-admin для управления группами доступа' }
              : { severity: 'error', summary: 'Не удалось загрузить группы доступа', detail: err?.message || 'Unknown error' });
          }
        });
  }

  addSecurityGroup(event) {
    this.securityGroupsEditor.push({ uid: -2, SECGROUPID: null, SECGROUPNAME: 'NEWSECURITYGROUP', SECGROUPDESC: 'Новая группа доступа', SECGROUPFLAG: 0 });

    var len = this.securityGroupsEditor.length;
    this.onRowEditInit(this.securityGroupsEditor[len - 1]);
    this.sgTable.initRowEdit(this.securityGroupsEditor[len - 1]);
  }

  onRowEditInit(esg: SecurityGroups) {
    console.log('*** EditUserAccessTabComponent in onRowEditInit: entry');
    //environment.production || console.table(esg);

    let newCloneIndex: number = 0;

    /*
     * Quite tricky algoritm:
     * Because we can edit simultaneously more than one row in the table.
     * Therefore for every edited row we have to create cloned copy in shadow array [securityGroupsClone]
     * We can't predict the order of starting and ending the edit process
     * 
     * So - Search for max cloneIndex in current table and assign +1 to newly created row copy
     *
     * When row either cancelled or saved - clone index resetted to 0, clone copy deleted from shadow array
     *
     */
    this.securityGroupsClone.forEach(sg => { newCloneIndex = Math.max(newCloneIndex, sg.cloneIndex) });

    console.log('*** EditUserAccessTabComponent in onRowEditInit: newCloneIndex is: ' + newCloneIndex);

    esg.cloneIndex = ++newCloneIndex;
    this.securityGroupsClone.push({ ...esg });
  }

  onRowEditCancel(esg: SecurityGroups, index: number) {
    console.log('*** EditUserAccessTabComponent in onRowEditCancel: ' + index);
    //environment.production || console.table(esg);

    if (esg.uid == -2) {
      // Cancel the newly created record
      // simply delete

      this.securityGroupsEditor.splice(index, 1);

    } else {
      // Cancel editing of existing record
      // have to reload it from database

      this.securityGroupsEditor[index] = { ...this.securityGroupsClone.find(sg => sg.cloneIndex == esg.cloneIndex) };
      this.securityGroupsEditor[index].cloneIndex = 0;
    }

    this.securityGroupsClone
      .splice(this.securityGroupsClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex), 1);
  }

  onRowEditSave(esg: SecurityGroups) {
    console.log('*** EditUserAccessTabComponent in onRowEditSave: ');
    //environment.production || console.table(esg);

    // Prompt 13-J (2026-08-24, closing SEC-3): putSecurityGroup/postSecurityGroup's
    // implementations were swapped to match their names (create/update) --
    // this ternary's branches swapped to match. uid == -2 still means "new row".
    this.saveSecurityQuery =
      concat(((esg.uid == -2) ? this.secApi.postSecurityGroup(esg) : this.secApi.putSecurityGroup(esg))
        .pipe(
          map((count) => console.log('*** EditUserAccessTabComponent in onMapSave result: ' + count)))
      )
        .subscribe(() => {
          console.log('*** EditUserAccessTabComponent in onSubsribe to Save: ');
          esg.uid = esg.SECGROUPID;
          this.securityGroupsClone
            .splice(this.securityGroupsClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex), 1);
          esg.cloneIndex = 0;
        });
  }

  buttonClick(event) {
    console.log('*** EditUserAccessTabComponent in buttonClick: ' + JSON.stringify(event));
  }

  reloadTable(event) {
    this.loadAccessGroupsInfo();
  }
}
